import React, { Component } from 'react';
import { connect } from 'react-redux';
import SiteSearchView from './site-search-view';

class SiteSearch extends Component {
  render() {
    return (
      <SiteSearchView {...this.props} />
    )
  }
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SiteSearch);




// WEBPACK FOOTER //
// ./src/components/layout/site-search.js